/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Slide_DuplicateInputs */



/**
* | output |
* | --- |
* | "Duplicate slide" |
*
* @param {Presentation_Slide_DuplicateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_slide_duplicate = /** @type {((inputs?: Presentation_Slide_DuplicateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Slide_DuplicateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Folie duplizieren")
	return /** @type {LocalizedString} */ ("Duplicate slide")
});